<template>
  <div class="videos">
    <div class="palyvideo" v-if="video_show">
        <img src="../../assets/lives/video_guan.png" alt="" @click.stop="close_video">
        <div style="background-color: #000;" id="asasd"></div>
    </div>
    <div class="videos_list">
        <div v-for="item in vlist" @click="playvideo(item)">
            <img :src="item.recFirstFrameUrl" alt="">
            <div>{{item.name}}</div>
        </div>
    </div>
    <div style="color:#ccc;padding:30px;">
            暂无更多视频
    </div>
  </div>
</template>

<script>
import home from "../../views/HomeView.vue"
import Player from 'xgplayer/dist/simple_player'
import volume from 'xgplayer/dist/controls/volume'
import playbackRate from 'xgplayer/dist/controls/playbackRate'
import HlsJsPlayer from "xgplayer-hls.js"
var hlsJsPlayer1

export default {
  name: 'videos',
  comments:{
  },
  props: {

  },
  created() {

  },
  mounted() {
    this.getroombindvideos()

  },
  data() {
    return {
        vlist:[],
        videoposter:'',
        videourl:'',
        video_show:false,
    }
  },
  methods: {
    //获取视频信息
    getroombindvideos(){
        this.$api.getroombindvideos().then(res=>{
            console.log(res.data.data);
            this.vlist = res.data.data
        })
    },
    //点击播放视频
    playvideo(e){
        if(hlsJsPlayer1 != undefined){
            hlsJsPlayer1.destroy()
        }
        this.video_show = true
        var backinfourl = e.path
        if (backinfourl.indexOf('http:') == 0) {
          backinfourl = backinfourl.replace('http:','')
        }
        else{
          backinfourl = backinfourl.replace('https:','')
        }
        this.$nextTick(()=>{
            hlsJsPlayer1 = new HlsJsPlayer({
            id: 'asasd',
            url: backinfourl,
            width:'100%',
            height:'100%',
            playbackRate: [0.5, 0.75, 1, 1.5, 2], //传入倍速可选数组
            ignores: ['error']
            });
        })
        home.methods.stoplive()
    },
    //关闭视频
    close_video(){
        this.video_show = false
        home.methods.playlive()
        },
  },

}
</script>
<style scoped>
.videos{
    width: 90vw;
}
.videos_list{
    text-align: left;
    padding-top: 50px;
    width: 100%;
    overflow: hidden;
}
.videos_list>div{
    float: left;
    margin-left: 35px;
    width: 240px;
    margin-bottom: 24px;
    height: 200px;
}
.videos_list>div img{
    width: 240px;
    height: 135px;
    border-radius: 10px;
    margin-bottom: 16px;
}
.videos_list>div div{
    text-align: center;
    font-size: 14px;
    color: #555555;
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
}
.palyvideo{
    position: absolute;
    margin-top: 110px;
    top: 0;
    height: 76vh;
    z-index: 300;
    width: 67vw;
}
.palyvideo>img{
    width: 24px;
    height: 24px;
    position: absolute;
    z-index: 99;
    right: 20px;
    top: 20px;
}
</style>
